import { useSetupHeadphoneListener } from '../useSetupHeadphoneListener';
import { useSetupTrackPlayer } from '../useSetupTrackPlayer';

export const useSetupNativeAVEvents = (): void => {
  useSetupHeadphoneListener();
  useSetupTrackPlayer();
};
